/**
 * Derives the current set of feature flags from an app configuration object.
 * Use this as the single source of truth for flag evaluation across all environments.
 */
export const getFeatureFlags = (config) => ({
    aiFeatures: config?.premium?.aiFeatures === true,
    respondentConfirmationNotifications: config?.premium?.respondentConfirmationNotifications === true,
    nextAvailableBookings: config?.premium?.nextAvailableBookings === true,
    companies: config?.others?.companies === true,
});
//# sourceMappingURL=featureFlags.js.map